import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "../App";
import { Phone, AlertCircle, PawPrint } from "lucide-react";

export default function Scan() {
  const { petId } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    axios.get(`${API}/scan/${petId}`).then(r => setData(r.data)).catch(() => setErr(true));
  }, [petId]);

  if (err) return (
    <div className="min-h-screen bg-bg grid place-items-center p-6">
      <div className="bg-surface border border-line rounded-3xl p-8 max-w-md text-center">
        <AlertCircle className="w-12 h-12 text-danger mx-auto mb-2"/>
        <div className="font-heading text-xl font-extrabold">Pet not registered</div>
        <p className="text-ink-soft mt-2">This QR code doesn't match a registered PetBond pet.</p>
        <Link to="/" className="mt-4 inline-block bg-ink text-white rounded-full px-5 py-2 text-sm font-bold">Visit PetBond</Link>
      </div>
    </div>
  );

  if (!data) return <div className="min-h-screen bg-bg grid place-items-center"><div className="text-ink-soft">Loading…</div></div>;

  return (
    <div className="min-h-screen bg-bg paw-bg" data-testid="scan-page">
      <header className="px-6 py-5 flex items-center gap-2">
        <div className="w-9 h-9 rounded-2xl bg-brand grid place-items-center"><PawPrint className="w-4 h-4 text-white"/></div>
        <span className="font-heading text-xl font-extrabold">Pet<span className="text-brand">Bond</span></span>
      </header>
      <main className="max-w-md mx-auto px-6 pt-6">
        <div className="bg-surface border border-line rounded-3xl overflow-hidden shadow-soft">
          <img src={data.pet.photo} className="w-full h-60 object-cover" alt={data.pet.name}/>
          <div className="p-6">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-brand">Hi! I'm</div>
            <h1 className="font-heading text-4xl font-extrabold leading-none mt-1">{data.pet.name}</h1>
            <div className="text-ink-soft mt-1">{data.pet.breed} · {data.pet.species}</div>
            <div className="text-xs text-ink-soft mt-2">Microchip: <span className="font-bold text-ink">{data.microchip_id}</span></div>

            <div className="mt-6 bg-leaf/30 rounded-2xl p-4">
              <div className="text-xs font-bold uppercase tracking-wider text-ink-soft">{data.message}</div>
              <div className="font-heading text-lg font-bold mt-1">{data.owner.name}</div>
              <a href={`tel:${data.owner.phone}`} className="mt-3 inline-flex items-center gap-2 bg-brand text-white rounded-full px-5 py-3 font-bold w-full justify-center hover:bg-brand-hover">
                <Phone className="w-4 h-4"/> Call owner — {data.owner.phone}
              </a>
            </div>
          </div>
        </div>
        <Link to="/" className="block text-center mt-6 text-sm text-ink-soft hover:text-brand">Powered by PetBond</Link>
      </main>
    </div>
  );
}
